import * as angular from "angular";
import {User, CurrentUser} from "../../models/user/user.model";
import {ApiUrl} from "../../models/app-config.model";

interface UserResponse { data: User; }

export interface UserService {
    get: () => angular.IPromise<CurrentUser>;
    getNoCache: () => angular.IPromise<CurrentUser>;
}

/* @ngInject */
export function userService(API_URL: ApiUrl, $http: angular.IHttpService): UserService {

    return {
        get: () => {
            return $http.get(API_URL.currentuser, { cache: true }).then((response: UserResponse) => {
                return new CurrentUser(response.data);
            });
        },
        getNoCache: () => {
            return $http.get(API_URL.currentuser).then((response: UserResponse) => {
                return new CurrentUser(response.data);
            });
        }
    };
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/user/user.service.ts
 **/